import { render, staticRenderFns } from "./appInfoDetails.vue?vue&type=template&id=087570b2&scoped=true"
import script from "./appInfoDetails.vue?vue&type=script&lang=js"
export * from "./appInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./appInfoDetails.vue?vue&type=style&index=0&id=087570b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087570b2",
  null
  
)

export default component.exports